import type {
	DataSourceDataParams,
	DataSourcePropFilterValue,
	DataSourcePropGroupBy,
	DataSourceSortInfo,
} from "@infinite-table/infinite-react";
import type { News } from "epsm-api-types/models";
import { DEFAULT_GRID_PAGE_SIZE } from "@/shared/constants/common";
import { LOCAL_FIELDS, NEWS_COLUMNS } from "./types";

const useFiltering = true;
const DEFAULT_PAGE_SIZE = DEFAULT_GRID_PAGE_SIZE;
const DEFAULT_FILTER_DELAY = 400;
const defaultGroupBy: DataSourcePropGroupBy<News> = [];

const sourceMapping = new Map<string, string>([
	["yahoo", "YN"],
	["google", "GOO"],
	["intrinio", "INT"],
	["bloomberg", "BBG"],
	["bbc", "BBC"],
	["reuters", "RTR"],
	["factset", "FST"],
	["morningstar", "MST"],
	["moody", "MOO"],
	["default", "WEB"],
]);

const defaultSortInfo: DataSourceSortInfo<News> = [
	{
		field: NEWS_COLUMNS.PUBLICATION_DATE,
		dir: -1,
	},
	{
		field: LOCAL_FIELDS.COMPANY_TICKER as unknown as keyof News,
		dir: 1,
	},
];

const defaultFilterValue: DataSourcePropFilterValue<News> | undefined =
	useFiltering ? [] : undefined;

const shouldReloadData = {
	sortInfo: true,
	filterValue: useFiltering,
};

const DETAILS_HEIGHT = {
	COLLAPSED: 120,
	EXPENDED: 250,
};

export type DefaultColumn = Array<keyof News | "_id">;
const DEFAULT_COLUMN_ORDER_OPTIONS: DefaultColumn = [
	"_id",
	"summary",
	"sentiment",
	"significancy",
	"url",
	"title",
	"sector",
	"ticker",
	"publication_date",
	"dataset",
	"datasource",
	"briefs",
	"category",
	"related_sources",
	"source",
	"topics",
	"company",
];

const DEFAULT_COLUMN_ORDER: string[] = [
	"publication_date",
	"estimate",
	"ticker",
	"title",
	"sector",
	"type",
	"category",
];

const EXTRA_FILTERS_FOR_NEWS = ["all", "top", "other"];

const initialDataParams: Partial<DataSourceDataParams<News>> = {
	groupBy: defaultGroupBy,
	sortInfo: defaultSortInfo,
	filterValue: defaultFilterValue,
	livePaginationCursor: 0,
};

export default {
	initialDataParams,
	useFiltering,
	DEFAULT_FILTER_DELAY,
	DEFAULT_PAGE_SIZE,
	DETAILS_HEIGHT,
	DEFAULT_COLUMN_ORDER_OPTIONS,
	DEFAULT_COLUMN_ORDER,
	EXTRA_FILTERS_FOR_NEWS,
	sourceMapping,
	defaultSortInfo,
	defaultFilterValue,
	defaultGroupBy,
	shouldReloadData,
};
